import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { InquiryIsUpdated, InquiryUpdateComplete } from '@tv3/store/inquiry/inquiry-fields.actions'
import { LoadInquiryDetails } from '@tv3/store/inquiry/inquiry.actions'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { BdcRtbDecisionPayload } from './bdc-request-to-book.model'

// TV4-6322: approve or decline a Booking.com Request to Book request.
@Injectable({ providedIn: 'root' })
export class BdcRequestToBookService {
  constructor(private http: HttpClient, private store: Store<any>) {}

  decide(inquiry: Inquiry, payload: BdcRtbDecisionPayload): Observable<any> {
    const url = `@api/bdc/rtb/request/${inquiry.id}`
    return this.http.put<any>(url, payload).pipe(
      tap((data) => {
        const changes = { status: data?.status, attributes: data?.attributes, archived: data?.archived }
        this.store.dispatch(InquiryUpdateComplete({ update: { id: inquiry.id, changes } }))
        this.store.dispatch(InquiryIsUpdated({ update: { id: inquiry.id, changes } }))
      })
    )
  }

  // The request expired or was handled in the Extranet: the backend already refreshed it.
  refresh(inquiry: Inquiry) {
    this.store.dispatch(LoadInquiryDetails({ id: inquiry.id }))
  }
}
